

























import Vue from 'vue';
import ActionLink from '@/components/ActionLink.vue';
import ValidationCodeInput from '@/components/ValidationCodeInput.vue';
import i18n from '@/i18n';

export default Vue.extend({
  components: {
    ActionLink,
    ValidationCodeInput,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    selectedChannel: {
      type: String,
      required: true,
    },
  },
  computed: {
    changeSelectedChannelLabel(): string {
      const channelKey = this.selectedChannel === 'email' ? 'mobilePhone' : 'email';
      const channel = i18n.t(channelKey).toLowerCase();

      return i18n.t('sendCodeBy', { channel });
    },
    isEmailAndPhone(): boolean {
      return this.selectedChannel === 'emailAndPhone';
    },
    firstLink(): object {
      const phoneLabel = i18n.t('mobilePhone').toLowerCase();
      return this.isEmailAndPhone
        ? {
            channel: 'phone',
            label: i18n.t('sendCodeBy', { channel: phoneLabel }),
          }
        : {
            channel: undefined,
            label: i18n.t('sendNewCode'),
          };
    },
  },
  methods: {
    clearHandler() {
      this.$emit('clear');
    },
    doneHandler(code: string) {
      this.$emit('done', code);
    },
    navigateToChangePhone() {
      this.$emit('changePhone');
    },
    sendNewCode(selectedChannel?: string) {
      this.$emit('sendNewCode', selectedChannel);
    },
    toggleSelectedChannel() {
      const newSelectedChannel = this.selectedChannel === 'email' ? 'phone' : 'email';
      this.sendNewCode(newSelectedChannel);
    },
  },
});
